import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import format from "date-fns/format";
import cn from "classnames";

import { getFormattedEntity } from "helpers/chats";

import FileMessage from "../FileMessage";
import SystemMessage from "../SystemMessage";
import ReviewMessage from "../ReviewMessage";

import { FORMAT_TIME } from "constants/time";
import { MESSAGE_TYPE } from "constants/chatConstants";

import styles from "./styles.module.scss";

const Message = ({ message, companionAvatar, employee, isInDealGroup = false }) => {
    const { t } = useTranslation();
    const profile = useSelector((state) => state.profile.profileData);
    const companionAvatarMessage = companionAvatar
        ? {
              backgroundImage: `url(${companionAvatar})`,
          }
        : {};
    const profileAvatarMessage = profile.picture
        ? {
              backgroundImage: `url(${profile.picture})`,
          }
        : {};
    const isMyMessage = message.from_user_id === profile.id;
    const systemUser = isMyMessage ? profile : employee;

    // Wrapper: если внутри группы сделки - div, иначе li
    const Wrapper = isInDealGroup ? 'div' : 'li';

    switch (message.type) {
        case MESSAGE_TYPE.MESSAGE:
        case MESSAGE_TYPE.REPLY:
            return (
                <Wrapper
                    className={cn(
                        styles.message__item,
                        message.from_user_id === profile.id && styles["message__item--mine"],
                        isInDealGroup && styles.message__inGroup,
                    )}
                >
                    {isMyMessage ? (
                        <span className={styles.message__avatar} style={profileAvatarMessage} />
                    ) : (
                        <span className={styles.message__avatar} style={companionAvatarMessage} />
                    )}
                    <div className={styles.message__content}>
                        <div className={styles.message__message}>
                            {message.type === MESSAGE_TYPE.REPLY && (
                                <span className={styles.message__messageReply}>
                                    {getFormattedEntity(t, message.item)}
                                </span>
                            )}
                            {message.files_data && message.files_data.length > 0 && (
                                <FileMessage files={message.files_data} />
                            )}
                            {message.message && (
                                <span
                                    className={cn(
                                        styles.message__messageText,
                                        message.files_data && styles.message__withFile,
                                    )}
                                >
                                    {message.message}
                                </span>
                            )}
                        </div>
                        <p className={styles.message__date}>
                            {format(new Date(message.created_at), FORMAT_TIME)}
                        </p>
                    </div>
                </Wrapper>
            );
        case MESSAGE_TYPE.SYSTEM:
            return (
                <Wrapper className={cn(
                    styles.message__system,
                    isMyMessage && styles['message__system--mine'],
                    isInDealGroup && styles['message__system--inGroup']
                )}>
                    <SystemMessage
                        message={message.message}
                        item={message.item}
                        user={systemUser}
                    />
                </Wrapper>
            );
        case MESSAGE_TYPE.REVIEW:
            return (
                <Wrapper className={cn(
                    styles.message__system,
                    isMyMessage && styles['message__system--mine'],
                    isInDealGroup && styles['message__system--inGroup']
                )}>
                    <ReviewMessage message={message} />
                </Wrapper>
            );
        default:
            return null;
    }
};

export default Message;
